export default __webpack_public_path__ + "static/media/ringback.37cb86b2.aac";